const types = {
    SET_USERS: '[INFORMATION] SET USERS',
    SET_SPIN: '[INFORMATION] SET SPIN',
    SET_DETALIZATION_SPIN: '[INFORMATION] SET DETALIZATION SPIN',
    SET_DETALIZATION: '[INFORMATION] SET DETALIZATION',
    SET_NEW_USERS: '[INFORMATION] SET NEW USERS',
    SET_COUNT_ONLINE: '[INFORMATION] SET COUNT ONLINE'
}

export {
    types
}